<div class="page-content page-fill flex-row">
  <div class="flex-row flex-fill">
    @if (auctionPurchases) {
      <div class="grid-fill reconciliation-data-grid" style="max-width: 99%">
        <dx-data-grid
          #dataGrid
          [dataSource]="auctionPurchases"
          keyExpr="id"
          height="100%"
          [showBorders]="true"
          [columnAutoWidth]="false"
          [focusedRowEnabled]="false"
          [showColumnLines]="true"
          [wordWrapEnabled]="true"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          (onRowDblClick)="rowDoubleClick($event)"
          >
          <dxi-column dataField="id" caption="Id" width="60" [sortIndex]="1" [sortOrder]="'desc'" [alignment]="'left'" ></dxi-column>
          <dxi-column dataField="auctionItem.type" caption="Type" width="80"></dxi-column>
          <dxi-column dataField="auctionItem.name" caption="Item" width="180"></dxi-column>
          <dxi-column dataField="auctionItem.description" caption="Desc" width="300"></dxi-column>
          <dxi-column dataField="auctionPaddleUser.name" caption="Person" width="200"></dxi-column>
          <dxi-column dataField="auctionPaddleUser.auctionPaddle.paddleNumber" caption="Paddle#" width="100"></dxi-column>
          <dxi-column dataField="quantity" caption="Qty" width="65"></dxi-column>
          <dxi-column dataField="amount" [format]="{ type: 'currency', precision: 2 }" width="110"></dxi-column>
          <dxi-column dataField="lineTotal" caption="Total" [format]="{ type: 'currency', precision: 2 }" width="110"></dxi-column>
          <dxi-column dataField="auctionItem.isDonationQualified" caption="Donation Item" width="110"></dxi-column>
          <dxi-column width="50"></dxi-column>
          <dxo-state-storing [enabled]="true" type="localStorage" storageKey="auction-purchases-list-grid"></dxo-state-storing>
          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxo-selection [mode]="'single'"></dxo-selection>
          <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
          <div *dxTemplate="let data of 'toolbarButtons'">
            <button class="btn btn-success" (click)="addPurchase()">Record Purchase</button>
            <button
              class="btn btn-danger ms-2"
              (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
              [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
              >
              Delete Purchase
            </button>
          </div>
          <div *dxTemplate="let data of 'toolbarText'">
            @if (auctionPurchases) {
              <span class="me-3">
                <strong>{{ dataGrid.instance.totalCount() + " paddles" }}</strong>
              </span>
            }
          </div>
        </dx-data-grid>
      </div>
    }
  </div>
</div>
